module.exports = __webpack_public_path__ + "static/media/lives-litter-free-rivers-and-streams.dd160552.jpg";